module.exports = __webpack_public_path__ + "img/i-community-mono.58f179c1.svg";